import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useLicensedProductsQueryForGlobalAppShortcutsQuery from './hooks/__generated__/useLicensedProductsQueryForGlobalAppShortcutsQuery.graphql.ts';
import type {
	useLicensedProductsQueryForGlobalAppShortcutsQuery$data,
	useLicensedProductsQueryForGlobalAppShortcutsQuery$variables,
} from './hooks/__generated__/useLicensedProductsQueryForGlobalAppShortcutsQuery.graphql.ts';

export async function preloadGlobalAppShortcutsLicensedProducts() {
	return query<
		useLicensedProductsQueryForGlobalAppShortcutsQuery$data,
		useLicensedProductsQueryForGlobalAppShortcutsQuery$variables
	>({
		query: useLicensedProductsQueryForGlobalAppShortcutsQuery,
	});
}
